import React, {useEffect, useState, useContext} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Select, { SelectOption } from "@amzn/meridian/select";
import Input from "@amzn/meridian/input"
import Text from "@amzn/meridian/text"
import Button from "@amzn/meridian/button";
import Alert from "@amzn/meridian/alert"
import axios from "axios";
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint, getNodeId} from "../../Utils";
import {fetchAllPrograms} from "../../NetworkUtils";
import {ALERT_TYPES} from "../../Constants";
import PageHeader from "../util/PageHeader";
import {NO_PERMISSION_ERROR, PAGE_HEADERS} from "../util/RouteConstants";
import {PermissionsContext} from "../permissions/PermissionContext";
import ErrorPage from "../error/ErrorPage";


const EnableProgram = () => {
    // Checking editor permission
    const {isEditor} = useContext(PermissionsContext);
    if (isEditor === false){
        return <ErrorPage errorTitle="Something went wrong" errorMessage={NO_PERMISSION_ERROR} />;
    }

    const [programName, setProgramName] = useState();
    const [mcmId, setMcmId] = useState();
    const [alert, setAlert] = useState({visible: false, text:"", type:""})
    const [programList, setProgramList] = useState([]);
    const warningAlert = {visible: true, text: "Enable Program request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully enabled Program", type:ALERT_TYPES.SUCCESS};


    useEffect(() => {
        fetchAllPrograms().then(response => setProgramList(response))
    }, []);

    const nodeId = getNodeId();
    function enableProgram () {
        setAlert(warningAlert);
        const params = { program: programName, nodeId: nodeId, mcmId: mcmId};
        (async ()=>{
            const headers  = await getHeadersForNFMS("EnableProgram");
            axios
                .post(getNFMSEndpoint(), params, headers)
                .then((response) => {
                    if (response.status === 200 && response.data.isSuccess === true) {
                        setAlert(successAlert);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                })
        })();
    }

    return (
        <div className="App">
            <Column spacingInset={"small large"}>
                <Row widths={["grid-12"]} alignmentVertical="top" >
                    <PageHeader {...PAGE_HEADERS.ENABLE_PROGRAM} />
                </Row>
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="enableProgram.programName" defaultMessage="Program Name"/>
                        </Text>
                        <Select value={programName} onChange={setProgramName} placeholder="Select Program Name" width={400}>
                            {programList.map(program => (
                                <SelectOption label={program} value={program} key={program} />
                            ))}
                        </Select>
                    </Column>
                </Row>

                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="enableProgram.mcm" defaultMessage="MCM Id"/>
                        </Text>
                        <Input id="mcm-input" value={mcmId} onChange={setMcmId} type="text" placeholder="Enter MCM Id" width={400}/>
                    </Column>
                </Row>

                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="enableProgram.nodeId" defaultMessage="Node Id"/>
                        </Text>
                        <Input id="nodeId-input" disabled={true} value={nodeId} type="text" width={400}/>
                    </Column>
                </Row>

                <Row alignmentVertical="top" spacingInset="large large large none">
                    <Button onClick={() => enableProgram()}>
                        <FormattedMessage id="enableProgram.enable" defaultMessage="Enable Program"/>
                    </Button>
                </Row>
                <Row alignmentVertical="top" spacingInset="none none medium none">
                    {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
                </Row>
            </Column>
        </div>
    );
}

export default injectIntl(EnableProgram);




// WEBPACK FOOTER //
// ./src/components/enable-program/EnableProgram.js